module.exports = __webpack_public_path__ + "207a349049abc826e32320d665eb77a8.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-84.cur
// module id = 481
// module chunks = 0